import { ValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/validation-message-resolver';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class MinValidationMessageResolver implements ValidationMessageResolver<{ min: unknown }> {
  private readonly translateService = inject(TranslateService);

  readonly errorCode = Validators.min.name;

  getMessage(error?: { min: unknown }): string {
    return this.translateService.instant('label.validation.min', { value: error?.min });
  }
}
